import "react-toastify/dist/ReactToastify.css";
import "./index.module.less";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Col, Container, createTheme, NextUIProvider, Row } from "@nextui-org/react";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AppToolbar, BugReport, ErrorBoundary } from "./components";
import { checkIsDarkMode, DarkMode } from "./context/dark-mode-context";
import { WithResumeDataContext } from "./context/resume-data-context";
import { WithSessionContext } from "./context/session-context";
import { Home, Interactive, MyAccount, Presentation, ResumeManager } from "./pages";
var isDarkMode = checkIsDarkMode(); // annoyingly, this renders some stuff globally even if we're not using
// NextUI on a given route

var theme = createTheme({
  type: isDarkMode ? "dark" : "light"
});

var AppUI = function AppUI(_ref) {
  var children = _ref.children;
  var path = useLocation().pathname;
  var isPresentation = /\/presentation\//.test(path);
  if (isPresentation) return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  return /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: AdapterDateFns
  }, /*#__PURE__*/React.createElement(NextUIProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    css: {
      marginTop: 16
    },
    gap: 0
  }, /*#__PURE__*/React.createElement(AppToolbar, null), /*#__PURE__*/React.createElement(Row, {
    gap: 0
  }, /*#__PURE__*/React.createElement(Col, {
    css: {
      flexBasis: "100%"
    }
  }, children))), /*#__PURE__*/React.createElement(ToastContainer, {
    position: "top-right",
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    hideProgressBar: true,
    theme: isDarkMode ? "dark" : "light"
  })));
};

ReactDOM.render( /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(DarkMode, null, /*#__PURE__*/React.createElement(WithSessionContext, null, /*#__PURE__*/React.createElement(BrowserRouter, {
  basename: "/presentation"
}, /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
  path: ":resumeId",
  element: /*#__PURE__*/React.createElement(Presentation, null)
}))), /*#__PURE__*/React.createElement(BrowserRouter, {
  basename: "/"
}, /*#__PURE__*/React.createElement(WithResumeDataContext, null, /*#__PURE__*/React.createElement(AppUI, null, /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
  path: "/",
  element: /*#__PURE__*/React.createElement(Home, null)
}), /*#__PURE__*/React.createElement(Route, {
  path: "/interactive",
  element: /*#__PURE__*/React.createElement(Interactive, null)
}, /*#__PURE__*/React.createElement(Route, {
  path: "new",
  element: /*#__PURE__*/React.createElement(Interactive, null)
}), /*#__PURE__*/React.createElement(Route, {
  path: ":resumeId",
  element: /*#__PURE__*/React.createElement(Interactive, null)
})), /*#__PURE__*/React.createElement(Route, {
  path: "/my-account",
  element: /*#__PURE__*/React.createElement(MyAccount, null)
}), /*#__PURE__*/React.createElement(Route, {
  path: "/resumes",
  element: /*#__PURE__*/React.createElement(ResumeManager, null)
}), /*#__PURE__*/React.createElement(Route, {
  path: "/presentation/:resumeId",
  element: null
}))))))), /*#__PURE__*/React.createElement(BugReport, null))), document.getElementById("root"));